import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_SearchResult } from '@app/styles';
import { ModuleFE_FHIRQuery, ModuleFE_FHIRResource } from '../../_entity.js';
import { EditableDBItemV3 } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { Page_FHIRManager } from './Page_FHIRManager.js';
import { DBDef_FHIRQuery, DBDef_FHIRResource } from '@app/fhir-shared';
import { Editor_FHIRResource } from './Editor_FHIRResource/Editor_FHIRResource.js';
import { Editor_FHIRQuery } from './Editor_FHIRQuery/Editor_FHIRQuery.js';
import { ModulePackFE_FHIR } from '../../module-pack.js';
import { RoutePermissions } from '@nu-art/permissions-frontend';
export const workspaceKey_FHIRManager = 'workspace__fhir-resource-manager';
export const WorkspaceConfig_FHIRManager = {
    name: workspaceKey_FHIRManager,
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            { name: 'LeftPanel', key: 'list', visible: true, factor: 1.5 / 5, min: 450, data: {} },
            { name: 'RightPanel', key: 'editor', visible: true, factor: 3.5 / 5, min: 1100, data: {} },
        ]
    }
};
export const Route_FHIRManager = {
    key: 'fhir-manager',
    path: 'fhir-manager',
    // enabled: RoutePermissions(ModuleFE_SmartDoc.permissions.ui.Release),
    Component: Page_FHIRManager,
    modulesToAwait: ModulePackFE_FHIR,
    enabled: RoutePermissions(ModuleFE_FHIRQuery.permissions.Release),
};
export const SearchableItem_FHIRResource = {
    type: DBDef_FHIRResource.dbKey,
    entityName: DBDef_FHIRResource.entityName,
    module: ModuleFE_FHIRResource,
    route: Route_FHIRManager,
    groupId: ['FHIR Manager'],
    entityLabel: 'FHIR Resource',
    tags: [],
    mapper: resource => [resource.label],
    renderer: (resource, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: resource._id, itemKey: DBDef_FHIRResource.dbKey, itemLabel: resource.label, entityLabel: 'FHIR Resource', hierarchy: 'FHIR Manager', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const resource = ModuleFE_FHIRResource.cache.unique(id);
        if (!resource)
            throw new MUSTNeverHappenException(`Could not find a fhir resource for the given id ${id}`);
        const editable = new EditableDBItemV3(resource, ModuleFE_FHIRResource);
        return _jsx(Editor_FHIRResource, { editable: editable });
    }
};
export const SearchableItem_FHIRQuery = {
    type: DBDef_FHIRQuery.dbKey,
    entityName: DBDef_FHIRQuery.entityName,
    module: ModuleFE_FHIRQuery,
    route: Route_FHIRManager,
    groupId: ['FHIR Manager'],
    entityLabel: 'FHIR Query',
    tags: [],
    mapper: query => [query.label],
    renderer: (query, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: query._id, itemKey: DBDef_FHIRQuery.dbKey, itemLabel: query.label, entityLabel: 'FHIR Query', hierarchy: 'FHIR Manager', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const query = ModuleFE_FHIRQuery.cache.unique(id);
        if (!query)
            throw new MUSTNeverHappenException(`Could not find a fhir query for the given id ${id}`);
        const editable = new EditableDBItemV3(query, ModuleFE_FHIRQuery);
        return _jsx(Editor_FHIRQuery, { editable: editable });
    }
};
export const getFHIRManagerSearchItems = () => [SearchableItem_FHIRQuery, SearchableItem_FHIRResource];
//# sourceMappingURL=consts.js.map